import React, { useRef, useState } from 'react';
import { Loader, Dimmer, TableBody, TableCell, TableRow } from 'semantic-ui-react';
import Modal from 'react-bootstrap/Modal';
import axios from 'axios';
import { Mensaje, MensajeSiNo } from '../mensajes';
import moment from 'moment';
import CatalogoProductosExistencias from '../../catalogos/catalogoProductosExistencias';
import CatalogoAlmacen from '../../catalogos/catalogoAlmacen';
import { ModalReversarPagos } from './modalReversarPago';

export const ModalSupervisor = (props) => {

  var op = require('../../../public/modulos/datos');
  let token = sessionStorage.getItem('jwtToken');
  const fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'));
  const afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));


  const btnCancela = useRef();
  const btnAcepta = useRef();
  const btnSalir = useRef();
  const txtCodigo = useRef();
  const txtCedula = useRef();
  const txtHasta = useRef();
  const txtPorProduct = useRef();
  const txtNombreProducto = useRef();
  const txtTodosProduct = useRef();
  const txtTodosAlmacen = useRef();
  const txtPorAlmacen = useRef();
  const txtNombreAlmacen = useRef();
  const txtCodigoAlmacen = useRef();
  const txtNombre = useRef();
  const txtRif = useRef();
  const txtCbmrif = useRef();

  const [inputalmacen, setInputalmacen] = useState('');
  const [valalmacen, setValalmacen] = useState(null);
  const [valproducto, setValproducto] = useState(null);
  const [idusu, setIdusu] = useState(null);
  const [tiporif, setTipofic] = useState(null);
  const [mostrar1, setMostrar1] = useState(null);
  const [mostrar2, setMostrar2] = useState(null);
  const [parafecha, setParafecha] = useState('');
  const [desde, setDesde] = useState('');
  const [hasta, setHasta] = useState('');
  const [disponiblec, setDisponiblec] = useState('');
  const [numnota, setNumNota] = useState('');
  const [idclient, setIdclient] = useState('');
  const [vinpurt, setVinput] = useState(true);
  const [mostrarClavesup, setMostrarClavesup] = useState(false);
  const [valida2, setValida2] = useState(0);
  const [activate, setActivate] = useState(false);
  const [idproduct, setIdproduct] = useState('');
  const [estatus, setEstatus] = useState('');
  const [valida, setValida] = useState(0);
  const [filterFn, setFilterFn] = useState({ fn: items => { return items; } });
  const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [tituid, setTituid] = useState('');
  const [botones, setBotones] = useState({
    incluir: false,
    consultar: false,
    modificar: false,
    eliminar: false,
    aceptar: true,
    cancelar: true,
    catalogo: true,
    salir: false
  });


  const blanquear = () => {
    setActivate(false);
    setInputalmacen('');
    setParafecha('');
    setDisponiblec('');
    setNumNota('');
    setIdusu(null);
    setValida(0);
    setValida2(0);
    setIdclient('');
    setIdproduct('');
    setVinput(true);
    setMostrar1(false);
    setMostrar2(false);
    setEstatus("");
    setDesde('');
    setHasta('');
    setValalmacen(0);
    setValproducto(0);
  }

  const cancelar = () => {
    blanquear();
    props.onHideCancelar();
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    let sigue = true;
    if (props.ope === 3) {

      if (txtCedula.current.value === '') {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "¡ Introduzca el Número de Cédula del Supervisor !",
          icono: "informacion",
        });
        sigue = false;
        txtCedula.current.focus();
      }

      if (sigue === true) {
        let cedu = txtCedula.current.value.trim();
        let clav = txtCodigo.current.value.trim();
        seleccionarAcceso(cedu, clav);
      }

    }

  }

  const seleccionarAcceso = (cedula, clave) => {

    let endpoint = `${op.conexion}/api/athos/usuario/supervisor?cedula=${cedula}&clave=${clave}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.idusuario > 0) {
            setIdusu(response.data.idusuario);
            setMostrar1(true);      
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificacion",
              texto: "¡ Cédula y/o Clave Incorrecto !",
              icono: "informacion",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const onChange = (e) => {

    if (e.target.name === 'clave') {
      if (e.target.value !== '') {
        setVinput(false);
      }
    }

  }

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
  };

  const cerrarModal = () => {
    blanquear();
    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
  }

  const handleInputNumeroChange = (event) => {
    event.preventDefault();
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        if (event.target.name === "cedula") {
          txtCodigo.current.focus();
        } else if (event.target.name === "clave") {
          btnAcepta.current.focus();
        }
      }
    }
  };

  const mostrarPasswordsup = () => setMostrarClavesup(!mostrarClavesup);

  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {

        if (props.ope === 3) {
          txtCedula.current.focus();
        }


      }}
    >
      <Modal.Header className='azulGradiant2 header-modal'>
        <div className='fw-bold' style={{ color: "#fff" }}><h3>SUPERVISOR</h3></div>

        <a href='#' ref={btnSalir} disabled={botones.salir} onClick={cancelar} className='text-light' ><i className="fas fa-times fa-1x shadow" > {/* Salir */}</i></a>

      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#FFF" }}>
        <Mensaje mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === 'Exito.' ?
              cerrarModal() :
              setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
          }
          } />
        <MensajeSiNo mensaje={mensajesino}
          onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
        <Dimmer active={activate} inverted>
          <Loader inverted>cargando...</Loader>
        </Dimmer>
        <div className='col-md-12 row mx-auto px-0 m-0'>

          <div className='col-12 row m-0 px-0 py-2'>

            <fieldset className='row col-sm-12 mx-auto mb-1 px-0'>

              <div className='col'>
                <div className="input-group input-group-sm mb-2">
                  <label className="input-group-text" id="inputGroup-sizing-sm">CEDULA: </label>
                  <input autoComplete='off' type='text' name="cedula" ref={txtCedula} onKeyUp={handleInputNumeroChange} onBlur={handleInputNumeroChange} className="form-control bg-transparent fs-6 text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                </div>
                <div className="input-group input-group-sm">
                  <label className="input-group-text" id="inputGroup-sizing-sm">CLAVE DE SUPERVISOR: </label>
                  <input autoComplete='off' type={mostrarClavesup ? "text" : "password"} onChange={onChange} name="clave" ref={txtCodigo} onKeyUp={handleInputNumeroChange} className="form-control bg-transparent fs-6 text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                  <button
                    style={{ textAlign: "center", color: "white" }}
                    onClick={mostrarPasswordsup}
                    className="btn btn-sm btn-info"
                  >
                    <i
                      className="fa fa-eye-slash"
                    ></i>{" "}
                  </button>
                </div>
              </div>

            </fieldset>

          </div>

        </div>


      </Modal.Body >
      <Modal.Footer>
        <div className="row m-0 col-md-12 mx-auto">
          <div className='col-md-11 ml-auto px-0 m-0 d-flex justify-content-end'>
            <button ref={btnAcepta} disabled={vinpurt} onClick={onChangeValidar} className="btn btn-sm rounded-pill btn-primary mx-1"><i className="fas fa-check-circle">  Aceptar</i></button>
            <button ref={btnCancela} onClick={cancelar} className="btn btn-danger btn-sm rounded-pill mx-1"><i className="fas fa-window-close"> Cancelar</i></button>
          </div>
        </div>

      </Modal.Footer>
      <ModalReversarPagos
        show={mostrar1}
        ope={props.ope}
        idusuario={idusu}
        onCerrar={cancelar}
        onHideCancela={() => setMostrar1(false)}
      />
    </Modal >
  );
}




// WEBPACK FOOTER //
// ./src/components/ventas/modalSupervisor.js